/**
 * @generated SignedSource<<2849f299634c3a9be089df1b2daf0451>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending";
export type ProjectUpdateComposerEmbedQuery$variables = {
  isExistingUpdate: boolean;
  key: string;
  updateId: string;
};
export type ProjectUpdateComposerEmbedQuery$data = {
  readonly projectByKey?: {
    readonly state: {
      readonly value: ProjectStateValue | null;
    } | null;
    readonly targetDate: string | null;
    readonly targetDateConfidence: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectUpdateComposer">;
  } | null;
  readonly projectUpdate?: {
    readonly project: {
      readonly updates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly ari: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"EditProjectUpdate">;
  } | null;
};
export type ProjectUpdateComposerEmbedQuery = {
  response: ProjectUpdateComposerEmbedQuery$data;
  variables: ProjectUpdateComposerEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isExistingUpdate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v4 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v5 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v4/*: any*/)
},
v6 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v7 = {
  "kind": "ScalarField",
  "name": "targetDateConfidence"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "updateId"
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "ari"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v14 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v11/*: any*/),
    {
      "concreteType": "WorkspaceAIConfig",
      "kind": "LinkedField",
      "name": "aiConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "enabled"
        }
      ]
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "count"
},
v16 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v17 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v18 = {
  "kind": "ScalarField",
  "name": "summary"
},
v19 = {
  "kind": "ScalarField",
  "name": "title"
},
v20 = {
  "concreteType": "ProjectUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editDate"
    },
    (v16/*: any*/),
    (v18/*: any*/),
    {
      "concreteType": "UpdateNote",
      "kind": "LinkedField",
      "name": "notes",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v18/*: any*/),
        (v11/*: any*/)
      ]
    },
    (v11/*: any*/)
  ]
},
v21 = [
  {
    "kind": "ScalarField",
    "name": "newValue"
  },
  {
    "kind": "ScalarField",
    "name": "oldValue"
  },
  (v11/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v23 = {
  "kind": "ScalarField",
  "name": "name"
},
v24 = {
  "kind": "ScalarField",
  "name": "picture"
},
v25 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "url"
},
v27 = [
  (v12/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v28 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      (v24/*: any*/),
      (v22/*: any*/)
    ]
  },
  {
    "kind": "ScalarField",
    "name": "aaid"
  },
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectUpdateComposerEmbedQuery",
    "selections": [
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ProjectUpdateComposer"
              }
            ]
          }
        ]
      },
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "projectUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EditProjectUpdate"
              },
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "ProjectUpdateConnection",
                    "kind": "LinkedField",
                    "name": "updates",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "ProjectUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "updates(first:1)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectUpdateComposerEmbedQuery",
    "selections": [
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "latestUpdateDate"
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  (v15/*: any*/)
                ]
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v20/*: any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "hasUpdateId",
                    "value": false
                  }
                ],
                "concreteType": "ProjectChangelogItemConnection",
                "kind": "LinkedField",
                "name": "changelog",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "concreteType": "ProjectChangelogItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectChangelogItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ]
                  }
                ],
                "storageKey": "changelog(hasUpdateId:false)"
              },
              {
                "concreteType": "DraftUpdate",
                "kind": "LinkedField",
                "name": "draftUpdate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "input"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/)
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v11/*: any*/),
                  (v25/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "projectUpdate",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/),
              (v18/*: any*/),
              {
                "alias": "newProjectState",
                "concreteType": "ProjectState",
                "kind": "LinkedField",
                "name": "newState",
                "plural": false,
                "selections": (v4/*: any*/)
              },
              {
                "kind": "ScalarField",
                "name": "newTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "newTargetDateConfidence"
              },
              {
                "concreteType": "UpdateNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "archived"
                  },
                  (v11/*: any*/)
                ]
              },
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v17/*: any*/),
                  (v16/*: any*/),
                  (v20/*: any*/),
                  (v26/*: any*/),
                  {
                    "concreteType": "ProjectState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "label"
                      }
                    ]
                  },
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "ProjectUpdateConnection",
                    "kind": "LinkedField",
                    "name": "updates",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "ProjectUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "updates(first:1)"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "missedUpdate"
              },
              {
                "kind": "ScalarField",
                "name": "updateType"
              },
              (v16/*: any*/),
              {
                "concreteType": "ProjectChangelogItem",
                "kind": "LinkedField",
                "name": "changelog",
                "plural": true,
                "selections": (v21/*: any*/)
              },
              {
                "concreteType": "LearningConnection",
                "kind": "LinkedField",
                "name": "learnings",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "LearningEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Learning",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          },
                          (v13/*: any*/),
                          (v11/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": (v27/*: any*/)
                              },
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": (v27/*: any*/)
                              },
                              {
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": (v28/*: any*/)
                              },
                              (v16/*: any*/),
                              {
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "lastEditedBy",
                                "plural": false,
                                "selections": (v28/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastEditedDate"
                              }
                            ],
                            "type": "Highlight",
                            "abstractKey": "__isHighlight"
                          },
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "691c5d786cdbbe1a3ce4044ab91bf4e9",
    "id": null,
    "metadata": {},
    "name": "ProjectUpdateComposerEmbedQuery",
    "operationKind": "query",
    "text": "query ProjectUpdateComposerEmbedQuery(\n  $key: String!\n  $updateId: ID!\n  $isExistingUpdate: Boolean!\n) {\n  projectByKey(key: $key) @skip(if: $isExistingUpdate) {\n    state {\n      value\n    }\n    targetDate\n    targetDateConfidence\n    ...ProjectUpdateComposer\n    id\n  }\n  projectUpdate(id: $updateId) @include(if: $isExistingUpdate) {\n    ...EditProjectUpdate\n    project {\n      updates(first: 1) {\n        edges {\n          node {\n            ari\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment DraftProjectUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment EditProjectUpdate on ProjectUpdate {\n  id\n  uuid\n  summary\n  newProjectState: newState {\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    title\n    uuid\n    archived\n    id\n  }\n  project {\n    id\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    startDate\n    creationDate\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    url\n  }\n  missedUpdate\n  updateType\n  creationDate\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsInUpdate\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsInUpdate on ProjectUpdate {\n  project {\n    uuid\n    id\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment NewProjectUpdate on Project {\n  id\n  key\n  uuid\n  workspace {\n    uuid\n    id\n    aiConfig {\n      enabled\n    }\n  }\n  watchers {\n    count\n  }\n  creationDate\n  startDate\n  targetDate\n  state {\n    value\n  }\n  latestUserUpdate {\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n    id\n  }\n  ...ProjectTargetDateAutoUpdated\n  draftUpdate {\n    ...DraftProjectUpdate\n    input\n    id\n  }\n  url\n}\n\nfragment ProjectTargetDateAutoUpdated on Project {\n  key\n  targetDate\n  changelog(hasUpdateId: false) {\n    count\n    edges {\n      node {\n        newValue\n        oldValue\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateComposer on Project {\n  ...ProjectUpdateDueDateContext\n  ...NewProjectUpdate\n  draftUpdate {\n    ...DraftProjectUpdate\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment ProjectUpdateDueDateContext on Project {\n  state {\n    value\n  }\n  latestUpdateDate\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "275d9823ffbeb32d36e32704c0a2b4de";

export default node;
